export const faqs = [
  {
    id: "f1",
    group: "投稿方式",
    q: "看料爆料的投稿入口在哪里？",
    a: "在「投稿通道」页面填写线索表单即可完成提交，也可以直接发送到投稿邮箱 tips@kanliaobaoliao.com。两种方式都不需要注册账号，我们不会强制要求你留下真实身份信息。",
  },
  {
    id: "f2",
    group: "投稿方式",
    q: "私信投稿和表单投稿有什么区别？",
    a: "表单投稿适合一次性提交结构化线索，方便我们归档和跟进；私信投稿适合时断时续地补充材料、随时沟通。两条通道由同一支核实小组接收，没有优先级差异。",
  },
  {
    id: "f3",
    group: "投稿方式",
    q: "可以只提交一部分线索，剩下的稍后补充吗？",
    a: "完全可以。很多猛料都是分几次补齐的。你可以先在表单里写清关键点，标注「材料待补」，核实编辑会通过你留下的联系方式（如临时邮箱或加密通信方式）继续对接。",
  },
  {
    id: "f4",
    group: "隐私与安全",
    q: "提交线索后，平台会公开我的身份吗？",
    a: "不会。投稿人身份默认加密保存，仅在核实小组内部按需查看。对外发布的爆料理料会做匿名化处理，涉及的时间、地点、称谓都可能被模糊化，以降低投稿人的曝光风险。",
  },
  {
    id: "f5",
    group: "隐私与安全",
    q: "平台会要求我提供身份证或真实姓名吗？",
    a: "不需要。我们鼓励匿名投稿，不会强制核验真实身份。如果线索需要实名佐证才能推进，编辑会先说明原因并征得你同意，你有权拒绝并撤回已提交的材料。",
  },
  {
    id: "f6",
    group: "隐私与安全",
    q: "如果我发现线索有误，可以撤回吗？",
    a: "可以。在发布前，你随时可以联系核实编辑撤回或更正材料；发布后如发现事实性错误，我们会在原页面显著位置发布更正说明，而不是悄悄删除。",
  },
  {
    id: "f7",
    group: "核实与发布",
    q: "线索一般多久会得到处理？",
    a: "常规线索会在 12 小时内完成初步筛选并给出反馈。涉及多方取证、需要交叉比对的复杂线索，核实周期通常为 2 到 7 个工作日，我们会同步进度。",
  },
  {
    id: "f8",
    group: "核实与发布",
    q: "什么样的线索会被退回？",
    a: "明显的商业诋毁、无来源的攻击性指控、涉及他人隐私的非公共利益信息，以及完全无法佐证的单方说法，都会被退回。我们只发布与公众利益相关且能被交叉核实的内容。",
  },
  {
    id: "f9",
    group: "核实与发布",
    q: "「核实中」和「已核实」标注是什么意思？",
    a: "「核实中」表示我们已收到线索并掌握部分佐证，仍在补充比对；「已核实」表示关键事实已通过两个以上独立来源交叉确认；「多方求证」表示我们已向当事方发出问询，等待回应。",
  },
  {
    id: "f10",
    group: "内容与版权",
    q: "我提交的图片、聊天记录会被二次编辑吗？",
    a: "为保护当事人和投稿人，发布时通常会对头像、昵称、订单号等隐私信息做打码或模糊处理，但不会改变关键事实的表达。原始文件仅用于内部核实，不会外传。",
  },
];

export const testimonials = [
  {
    id: "t1",
    quote:
      "第一次投稿时很犹豫，怕被顺藤摸瓜。编辑主动教我怎么去掉截图里的水印和时间戳，最后发出来完全看不出是我给的料，这一点很难得。",
    author: "投稿人 · 代号「夜航」",
    role: "消费维权类线索提供者",
  },
  {
    id: "t2",
    quote:
      "我分三次补的材料，每次都能被接上，核实编辑会告诉我哪一段还缺佐证。不像有些地方投过去就石沉大海，这里是真的会把线索往下推。",
    author: "投稿人 · 代号「旧账本」",
    role: "行业内幕类线索提供者",
  },
  {
    id: "t3",
    quote:
      "提交后不到一天就收到初筛反馈，明确说哪部分能发、哪部分证据不足。这种有回应的投稿体验，比想象中靠谱太多了。",
    author: "投稿人 · 代号「站台」",
    role: "社会热点类线索提供者",
  },
];